// Go through all data and flatten commissionSummary
// When there is a person in commissions summary, create new row with policy

export default data => {
	let output = []

	data.forEach(item => {
		if (item.commissionSummary && item.commissionSummary.length > 0) {
			item.commissionSummary.forEach(summary => {
				const newItem = { ...item, commissionSummary: summary }
				output.push(newItem)
			})
		}
	})

	console.log({ output })

	return output
}
